"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_TEMPLATE_GENERATION_FILE_SIZE_LIMIT_IN_MB = exports.MAX_FORM_TEMPLATE_FIELD_GROUP_NAME_LENGTH = void 0;
var MAX_FORM_TEMPLATE_FIELD_GROUP_NAME_LENGTH = 250;
exports.MAX_FORM_TEMPLATE_FIELD_GROUP_NAME_LENGTH = MAX_FORM_TEMPLATE_FIELD_GROUP_NAME_LENGTH;

/** set by OpenAI, 10mb in July 2025 */
var FORM_TEMPLATE_GENERATION_FILE_SIZE_LIMIT_IN_MB = 10 * 1024 * 1024; // 10MB

exports.FORM_TEMPLATE_GENERATION_FILE_SIZE_LIMIT_IN_MB = FORM_TEMPLATE_GENERATION_FILE_SIZE_LIMIT_IN_MB;